exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader-wrapper{position:relative!important;margin:20% auto 0;width:200px;right:0!important;bottom:0!important;display:block!important}.wrapper{width:30px!important;height:30px!important}.spinner-circle{border-radius:50%!important;border-color:#333!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/App.vue
// module id = 154
// module chunks = 0